<div class="gpd-tabbed-page">
  <nav class="gpd-page-tabs">
    <a *ngFor="let tab of tabs" class="gpd-page-tab" [routerLink]="tab.link" routerLinkActive="active">
      {{ tab.text }}
    </a>
  </nav>
  <div class="gpd-tabbed-page-content">
    <router-outlet></router-outlet>
  </div>
</div>
